// extracted by mini-css-extract-plugin
export default {"container":"dL-z","topReviewHeading":"eL-z","criticalReview":"fL-z","favorableReview":"gL-z","vsSeparator":"hL-z"};